"use client";

import { motion, useMotionValue, useTransform } from "motion/react";
import Image, { ImageProps } from "next/image";
import React, { useState } from "react";

const EMOJIS = ["💖", "💘", "💞", "💗", "💓", "💝", "💟", "✨", "🩷", "🫶"];

interface HoverImageProps extends ImageProps {
  className?: string;
  priority?: boolean;
  fetchPriority?: 'high' | 'low' | 'auto';
}

export default function HoverImage({
  className,
  alt,
  priority = false,
  fetchPriority,
  ...props
}: HoverImageProps) {
  const [hover, setHover] = useState(false);
  const [emoji] = useState(() => EMOJIS[Math.floor(Math.random() * EMOJIS.length)]);

  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const left = useTransform(x, (val) => `${val - 12}px`);
  const top = useTransform(y, (val) => `${val - 12}px`);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    x.set(e.clientX - rect.left);
    y.set(e.clientY - rect.top);
  };

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onMouseMove={handleMouseMove}
      className={`relative overflow-hidden rounded-3xl border border-[#E9C46A]/40 shadow-sm ${
        hover ? "cursor-none" : "cursor-auto"
      } ${className}`} 
    >
      <Image
        {...props}
        alt={alt}
        priority={priority}
        loading={priority ? undefined : 'lazy'}
        fetchPriority={fetchPriority}
        className="w-full h-full object-cover no-hashtag-zone transition-transform duration-300 group-hover:scale-105"
      />

      {hover && (
        <motion.div
          className="absolute pointer-events-none text-3xl z-50"
          style={{ left, top }}
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: [0, 1.2, 1], opacity: 1 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          {emoji}
        </motion.div>
      )}
    </div>
  );
}
